import { useEffect, useRef } from 'react';

/**
 * Prevents scrolling of the page while the modal is open.
 * Uses a unified approach with additional touch event handling for iOS Safari.
 */
export function usePreventBodyScroll() {
    const scrollPositionRef = useRef(0);
    const originalPaddingRightRef = useRef('');

    useEffect(() => {
        const body = document.body;

        // Store current scroll position and original padding
        scrollPositionRef.current = window.pageYOffset || document.documentElement.scrollTop;
        originalPaddingRightRef.current = body.style.paddingRight;

        // Calculate scrollbar width and add padding to prevent content shift
        const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
        if (scrollBarWidth > 0) {
            body.style.paddingRight = `${scrollBarWidth}px`;
        }

        // Apply scroll prevention
        body.style.overflow = 'hidden';
        body.style.position = 'fixed';
        body.style.width = '100%';

        // Cleanup function
        return () => {
            // Restore original styles
            body.style.overflow = '';
            body.style.position = '';
            body.style.top = '';
            body.style.width = '';
            body.style.paddingRight = originalPaddingRightRef.current;
        };
    }, []);
}
